export class LocationUpdate {
    public readonly latitude: number;
    public readonly longitude: number;

    constructor(latitude : number, longitude : number) {
        this.latitude = latitude;
        this.longitude = longitude;
    }
}